import { defineMessages } from '@redbubble/next/intl';

export const messages = defineMessages({
  fitIndicatorTitle: {
    defaultMessage: 'Find your fit',
  },
  snugFitDescription: {
    defaultMessage:
      'Snug fit, order a size up for a standard fit or go up two sizes for a baggier fit.',
  },
  standardFitDescription: {
    defaultMessage: 'Standard fit, order a size up if you prefer a looser fit.',
  },
  relaxedFitDescription: {
    defaultMessage:
      'Relaxed fit, order your regular size for a looser fit or go down one size for more standard fit.',
  },
  oversizedFitDescription: {
    defaultMessage: 'Loose fit, order a size down for standard fit.',
  },
  premiumOversizedFitDescription: {
    defaultMessage:
      'Roomy sleeves, size up one if you like the body to fit more baggy.',
  },
  slim: {
    defaultMessage: 'Slim',
  },
  standard: {
    defaultMessage: 'Standard',
  },
  oversized: {
    defaultMessage: 'Oversized',
  },
  modalTitle: {
    defaultMessage: 'Size Guide',
  },
  productMeasurements: {
    defaultMessage: 'Product Measurements',
  },
  internationalConversions: {
    defaultMessage: 'International Conversions',
  },
  men: {
    defaultMessage: 'Men',
  },
  women: {
    defaultMessage: 'Women',
  },
  inches: {
    defaultMessage: 'IN',
  },
  centimeters: {
    defaultMessage: 'CM',
  },
  measurementsFootnote: {
    defaultMessage:
      'Product measurements refer to garment dimensions, not body size',
  },
  measurementUnit: {
    defaultMessage: 'Measurement unit',
  },
  gender: {
    defaultMessage: 'Gender',
  },
  howToChoose: {
    defaultMessage: 'How to choose the perfect size',
  },
  helpCenter: {
    defaultMessage: 'Help center',
  },
  returnsTitle: {
    defaultMessage: 'Returns are free and easy.',
  },
  returnsBody: {
    defaultMessage: 'Because you need to be happy. We all do.',
  },
  modelSize: {
    defaultMessage: 'Model size',
  },
  modelMeasurements: {
    defaultMessage: 'Model measurements',
  },
  openButtonText: {
    defaultMessage: 'View size guide',
  },
  modalAccessibleTitle: {
    defaultMessage: 'Size Guide',
  },
});
